export default "__VITE_ASSET__BBH2n5Lh__"